
import { Injectable }       from '@angular/core';
import { Headers }   from '@angular/http';
import { PrestacaoAluno } from './prestacao-aluno';
import { Observable }       from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';
import { map, catchError, publishReplay, refCount } from 'rxjs/operators';
import { HttpService } from 'ems-oauth2-client';

@Injectable()
export class PrestacaoAlunoService extends ServiceUtil  {

    private headers:Headers = new Headers({'Content-Type': 'application/json'});
    private url = '/editaldpg/prestacao/aluno';

    constructor(private http: HttpService, private pagerComponent: PagerComponent) { super(); }

    // altera ou inclui PrestacaoAluno
    public update(prestacaoAluno : PrestacaoAluno): Observable<PrestacaoAluno> {
        let body = JSON.stringify(prestacaoAluno);
        if(!prestacaoAluno.id){
          return this.http.post(this.url, body)
            .pipe(map(response => response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
        }else{
          return this.http.put(this.url + "/" + prestacaoAluno.id , body)
            .pipe(map(response => response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
        }
    }

    // deleta PrestacaoAluno
    public deletar(prestacaoAluno: PrestacaoAluno): Observable<PrestacaoAluno> {
      return this.http.delete(this.url + "/" + prestacaoAluno.id)
        .pipe(map(response =>  response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
    }

    // lista todos (sem filtro)
    public listar(): Observable<PrestacaoAluno[]> {
      return this.http.get(this.url)
            .pipe(map(response =>  response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
    }

    public validar(prestacaoAluno : PrestacaoAluno): Observable<PrestacaoAluno> {
      let body = JSON.stringify(prestacaoAluno);

      return this.http.put(this.url + "/" + prestacaoAluno.id + "/validar" , body)
          .pipe(map(response => response),
           catchError(this.handleError),
           publishReplay(1),
           refCount());
    }


    // recupera por id
    public getId(id : number): Observable<PrestacaoAluno> {
        return this.http.get(this.url + "/" + id)
                  .pipe(map(response => response),
                   catchError(this.handleError),
                   publishReplay(1),
                   refCount());
    }


    // filtra
    public filtrar(filtro : PrestacaoAluno): Observable<PrestacaoAluno[]>{
      let colocaVirgula = false;
      let novaUrl = "{" ;
      if(filtro.id){
       novaUrl += "id:\"" + filtro.id + "\"";
       colocaVirgula = true;
      }

      if(filtro.codigoInscricaoAluno){
        if(colocaVirgula){
          novaUrl += ", ";
        }
       novaUrl += "codigoInscricaoAluno:\"" + filtro.codigoInscricaoAluno + "\"";
       colocaVirgula = true;
      }


      if(filtro.respostaQuestionario){
        if(colocaVirgula){
          novaUrl += ", ";
        }
       novaUrl += "respostaQuestionario:\"" + filtro.respostaQuestionario + "\"";
       colocaVirgula = true;
      }

      novaUrl +=  "}";

      let urlModify = this.pagerComponent.formatarUrl(this.url,novaUrl,1000,0);


      return this.http.get(urlModify)
              .pipe(map(response =>{
                  var result = response;
                  PagerComponent.allItems = result;
                  return response;
              }),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
    }


}
